import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { MAIN_SITE_URL } from "@/mocks/categories";
import { useLocalizedLinks } from "@/hooks/useLocale";

export default function SafetyCta() {
  const { t } = useTranslation();
  const { to: linkTo } = useLocalizedLinks();

  return (
    <section id="safety" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="rounded-lg border border-accent-200 bg-accent-50 p-6 md:p-10">
          <div className="flex flex-col items-start gap-4 md:flex-row md:items-center md:gap-6">
            <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-lg bg-accent-500 text-background-50">
              <i className="ri-alert-line text-xl"></i>
            </span>
            <div className="flex-1">
              <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">
                {t("safety.title")}
              </h2>
              <p className="mt-2 text-sm leading-relaxed text-foreground-800 md:text-base">{t("safety.copy")}</p>
            </div>
            <Link
              to={linkTo("/usfans-spreadsheet-guide")}
              className="whitespace-nowrap rounded-md bg-accent-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-accent-600"
            >
              {t("safety.cta")}
            </Link>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center rounded-lg bg-primary-950 px-6 py-12 text-center md:py-16">
          <h2 className="font-heading text-2xl font-bold text-background-50 md:text-3xl">
            {t("mainCta.title")}
          </h2>
          <p className="mt-3 max-w-2xl text-sm leading-relaxed text-background-100/80 md:text-base">
            {t("mainCta.copy")}
          </p>
          <a
            href={MAIN_SITE_URL}
            target="_blank"
            rel="noopener nofollow"
            className="mt-7 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-400"
          >
            {t("cta.continueMain")}
            <span className="flex h-5 w-5 items-center justify-center">
              <i className="ri-arrow-right-up-line text-base"></i>
            </span>
          </a>
        </div>
      </div>
    </section>
  );
}